<section class="pw-notice" *ngIf="passwordNotice" aria-labelledby="pwNoticeTitle">
    <h2 id="pwNoticeTitle" class="pw-notice-title">Update Password Required</h2>
    <p class="pw-notice-body">Your password was set before our new password policy came into effect. Please choose a new password now to keep your account secure.</p>
    <a class="pw-notice-btn" [routerLink]="['/reset-password']">Reset Password</a>
</section>

<div class="dashboard-content-sec dash-col user-filter-space">
    <div class="loader" *ngIf="showloader">
        <img src="assets/images/loader.gif" alt="">
    </div>

    <div id="greeting" class="flex-cell">
        <div id="hello">
            <span>Hello, {{userData.FirstName}}</span>
        </div>
        <div id="welcomeBack">
            <span>Welcome back!</span>
            <span *ngIf="ClientName" class=""> {{ClientName}}</span>            
        </div>
    </div>


    <div class="flex-cell" *ngIf="this.canSeeTickets">
        <div id="ticket-tabs">
            <div class="tab" (click)="selectMe($event)" 
                data-toggle="collapse" data-target="#openTickets">
                Open Tickets
            </div>
            <div class="tab" style="margin-left: -18px;"  (click)="selectMe($event)" 
                data-toggle="collapse" data-target="#closedTickets">
                Closed Tickets
            </div>
        </div>
        <div id="dash-tickets" >
            <div id="tick-table">
                <div id="tick-header">
                    <div class="header rad-left">
                        <span>Subject</span>
                    </div>
                    <div class="header rad-right">
                        <span>Category</span>
                    </div>
                </div>
                <div id="tick-body" >
                    <div id="openTickets" class="collapse">
                        <ul>
                            <li *ngFor="let t of openTickets" class="bd-bottom">
                                <div class="bd-right cell" [title]="t.subject" (click)="selectTick(t.id)">
                                    {{ t.subject }}
                                </div>
                                <div class="cell" (click)="selectTick(t.id)">
                                    {{ subjectMatterLabel(t) }}
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div id="closedTickets" class="collapse">
                        <ul>
                            <li *ngFor="let t of closedTickets" class="bd-bottom">
                                <div class="bd-right cell"  [title]="t.subject" (click)="selectTick(t.id)">
                                    {{ t.subject }}
                                </div>
                                <div class="cell"  (click)="selectTick(t.id)">
                                    {{ subjectMatterLabel(t) }}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div id="createTick">
            <a href="javascript:void(0)" [routerLink]="['/add-ticket']" >
                Create Ticket
            </a>
        </div>
    </div>


    <div id="tools" class="flex-cell">
        <div class="header">
            Tools            
        </div>
        <div id="toolsbody">
            <div class="newsletter">
                <span class="banner">Newsletter</span>
                <span class="title">{{theNewsletter?.Title}}</span>
                <span class="overview">{{newsletterBrief}}
                    <a href="javascript:void(0)" (click)="selectNewsletter()">(View more ...)</a>
                </span>
                <span>
                  <a class="viewall" href="javascript:void(0)" [routerLink]="['/content/newsletter-list/']" routerLinkActive="active">
                     View All</a>
                </span>
            </div>

            <div class="butn-row mt-3">
                <ng-container *ngFor="let serv of servicesList; let idx = index;">
                    <div *ngIf="idx < 3" class="butn" (click)="askModal(serv.ID)">
                        {{serv.Title.substring(0,20)}}
                    </div>
                </ng-container>
            </div>
            <div class="butn-row">
                <ng-container *ngFor="let serv of servicesList; let idx = index;">
                    <div *ngIf="idx >= 3" class="butn" (click)="askModal(serv.ID)">
                        {{serv.Title.substring(0,20)}}
                    </div>
                </ng-container>
            </div>

        </div>
    </div>


    <div id="community" class="flex-cell">
        <div class="header">
            Community            
        </div>
        <div id="communitybody">
            <div class="butn-row pt-3">
                <div class="butn">
                    <a class="title" href="javascript:void(0)" [routerLink]="['/content/webinar-list/']" routerLinkActive="active" >                      
                      <span class="title">Webinars</span>
                    </a>
                    <div class="count">
                        <span>{{webinarsList?.length}}</span>
                    </div>                                         
                </div>
                <div class="butn">
                    <a class="title" href="javascript:void(0)" [routerLink]="['/content/tip-list/']" routerLinkActive="active">
                        HR Tools and Tips
                    </a>                       
                    <div class="count">
                        <span>{{tipsList?.length}}</span>
                    </div>                                         
                </div>
            </div>
            <div class="butn-row">
                <div class="butn">
                    <a class="title" href="javascript:void(0)" [routerLink]="['/content/news-list/']" routerLinkActive="active">
                        News
                    </a>
                    <div class="count">
                        <span>{{newsList?.length}}</span>
                    </div> 
                </div>
                <div class="butn">
                    <a class="title"  href="javascript:void(0)" [routerLink]="['/content/blog-list/']" routerLinkActive="active">
                        Blog
                    </a>
                    <div class="count">
                        <span>{{blogsList?.length}}</span>
                    </div> 
                </div>
            </div>
        </div>
    </div>

    <div id="states" class="flex-cell">
        <div class="header">
            State Updates          
        </div>
        <div id="statesbody">
            <div class="butn-row pt-3">
                <div class="butn" (click)="theStateGo()">
                    {{theState?.Name}}
                </div>
                <div class="butn">
                    <a href="javascript:void(0)" [routerLink]="['/state-update-list']" >
                        All States
                    </a>
                </div>
            </div>
        </div>
    </div>

        
</div>



<!-- 

<div class="card-group">
    <div class="row" style="width: 100%">
        <div class="col-md-5 col-lg-4">
            <div class="card hide-overflow">
                <div class="card-body">
                    <h5 class="text-center border-0">State Updates</h5>
                    <h5 *ngIf="ClientName" class="text-center card-title border-0">for {{ClientName}}</h5>
                    <div class="btn-group-vertical list-group">
                        <ng-container *ngFor="let state of displayStates">                                
                           <a href="javascript:void(0)" [routerLink]="['/state-update/', state.ID ]" routerLinkActive="active"
                           class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                            {{ state.Name }}
                            <span class="badge badge-primary badge-pill">{{ state.NewUpdates }}</span>
                        </a>
                        </ng-container>

                        <a href="javascript:void(0)" [routerLink]="['/state-update-list']" routerLinkActive="active"
                          class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                            All States
                            <span class="badge badge-primary badge-pill">{{ totalStateUpdates }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-md-6 col-lg-6">
            <div class="card hide-overflow">
                <div class="card-body">
                    <h5 class="text-center card-title border-0">Newsletters</h5>
                    <div class="btn-group-vertical list-group">
                        <ng-container *ngFor="let news of newslettersList | slice:0:4">
                            <a href="javascript:void(0)" [routerLink]="['/content/newsletter/', news.ID ]" routerLinkActive="active"
                              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                                {{ news.Title }}
                            </a>                                     
                        </ng-container>
                        <a href="javascript:void(0)" [routerLink]="['/content/newsletter-list/']" routerLinkActive="active"
                          class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                            More Newsletters
                            <span class="badge badge-primary badge-pill">{{ newslettersList?.length }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="row" style="width:100%">
        <div class="col-md-5 col-lg-4">
            <div class="card hide-overflow ">
                <h5 class="text-center card-title border-0">Community</h5>
                <div class="card-body">
                    <div class="btn-group-vertical list-group">
                        <a href="javascript:void(0)" [routerLink]="['/content/webinar-list/']" routerLinkActive="active" 
                          class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                            Webinars
                            <span class="badge badge-primary badge-pill">{{webinarsList?.length}}</span>
                        </a>
                        <a href="javascript:void(0)" [routerLink]="['/content/tip-list/']" routerLinkActive="active"
                           class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                            HR Tools & Tips
                            <span class="badge badge-primary badge-pill">{{tipsList?.length}}</span>
                        </a>
                        <a href="javascript:void(0)" [routerLink]="['/content/news-list/']" routerLinkActive="active"
                           class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                            News
                            <span class="badge badge-primary badge-pill">{{newsList?.length}}</span>
                        </a>
                        <a  href="javascript:void(0)" [routerLink]="['/content/blog-list/']" routerLinkActive="active"
                           class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                            Blogs
                            <span class="badge badge-primary badge-pill">{{blogsList?.length}}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6 col-lg-6">
            <div class="card hide-overflow">
                <div class="card-body">
                    <h5 class="text-center card-title border-0">Services</h5>
                    <div class="btn-group-vertical list-group">
                        <ng-container *ngFor="let serv of servicesList">
                            <a href="javascript:void(0)" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                            (click)="askModal(serv.ID)">
                               <div [innerHTML] = "serv.Title"></div>
                            </a>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div> -->




<!-- <div class="dashboard-content-sec">
    <div class="loader" *ngIf="showloader">
      <img src="assets/images/loader.gif" alt="">
    </div>
    <div class="card">
        <div class="card-title">
            <h3><img src="assets/images/statistics.svg" alt="">Ticket Status</h3>
        </div>
        <div class="card-content">
            <canvas height="300" #pieChart>{{ chart }}</canvas>
        </div>

    </div>
    <div class="card">
        <div class="card-title">
            <h3><img src="assets/images/recent-post.svg" alt="">Recent Tickets</h3>
        </div>
        <div class="card-content">

            <div class="row ">

                <div class="col-md-12 col-lg-6" *ngFor="let tkt of tickets | slice:0:10; let i=index">
                    <div class="row ticket-card d-flex justify-content-start no-gutters flex-column flex-sm-row mb-4">

                        <div class="mr-auto ticket-icon">
                            <img src="assets/images/status-open.svg" alt="" *ngIf="tkt.status==1">
                            <img src="assets/images/status-ok.svg" alt="" *ngIf="tkt.status==2">

                            <img src="assets/images/status-neutral.svg" alt="" *ngIf="tkt.status==3">
                        </div>
                        <div class="mr-auto mt-2 mb-2 mt-sm-0 mb-sm-0  ticket-author">
                            <span>{{tkt.requested}} | {{tkt.updated_at | date:'short'}}</span>
                        </div>
                        <div class="col-12 col-sm ticket-content align-self-center ml-0 ml-sm-4">
                            <p><a href="javascript:void(0)" [routerLink]="['/ticket',tkt.id,'edit']" >{{tkt.subject}} (#{{tkt.id}})</a></p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
